import { render, staticRenderFns } from "./add.vue?vue&type=template&id=e88faeb4&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./add.vue?vue&type=style&index=1&id=e88faeb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88faeb4",
  null
  
)

export default component.exports